import { useCallback, useEffect, useState } from 'react'
import { withAuthRecovery } from '@/lib/authRecovery'
import { supabase } from '@/lib/supabase'

/**
 * Может ли текущий пользователь заводить и править ДКК и ДС.
 *
 * Право с 01.09.2026 — «юрист (job_title = lawyer) или супер-администратор», а не
 * «любой advanced УК» (миграция 20260901140000). Источник истины — серверная
 * `can_manage_contracts()`, та же функция стоит в гейтах RPC; второй реализации
 * правила во фронте не заводить, иначе кнопка и сервер разойдутся.
 *
 * Ошибка запроса трактуется как «нельзя»: показать кнопку, которая гарантированно
 * упадёт на сервере, хуже, чем не показать её.
 */
export function useCanManageContracts() {
  const [canManage, setCanManage] = useState(false)
  const [loading, setLoading] = useState(true)

  const refresh = useCallback(async () => {
    setLoading(true)
    try {
      const { data, error } = await withAuthRecovery(() =>
        (supabase as any).rpc('can_manage_contracts')
      )
      if (error) throw error
      setCanManage(data === true)
      return data === true
    } catch (error) {
      console.error('Failed to load contract management permission:', error)
      setCanManage(false)
      return false
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void refresh()
  }, [refresh])

  return { canManage, loading, refresh }
}
